<template>
  <div class="row">
    <div class="col-12">
      <page-header :actions="headerActionsConfig" :page="headerConfig" />
    </div>
    <div class="col-12">
      <div class="pl-2">
        <board v-if="isReadOnly" :details="companyBoardDetails" />
        <ssn-search
          v-else
          :company-id="companyId"
          @change-ssn="onChangeSsnHandler"
          @search="onSearchSpecialistHandler"
        />
      </div>
    </div>
    <div v-if="isNew" class="col-12">
      <div class="pl-2">
        <validation-observer :ref="mainFormName" v-slot="{}" tag="form">
          <general-info
            ref="generalInfo"
            v-model="model.specialistInfo"
            class="my-5"
            :is-health-dept-no-enabled="isHealthDeptNoEnabled"
            :is-medicaid-documentation-workflow-enabled="
              isMedicaidDocumentationWorkflowEnabled
            "
            :is-new="isNew"
          />
          <licenses
            ref="licenses"
            v-model="model.licenses"
            :age-ranges="collections.ageRanges"
            class="my-5"
            :document-types="collections.specialistLicenseDocumentTypes"
            :show-license-form.sync="showLicenseForm"
            :specialist-id="specialistId"
            :specialist-info="model.specialistInfo"
            :specialty-types="collections.specialtyTypes"
            @delete="onDeleteSpecialistLicenseHandler"
            @delete-document="onDeleteSpecialistLicenseDocumentHandler"
            @delete-document-by-type="onDeleteDocumentByTypeHandler"
            @download-document="onDownloadDocumentHandler"
            @download-documents="onDownloadDocumentsHandler"
            @save="saveOrUpdateLicense"
            @update-specialist-info="saveSpecialistAddressInfo"
            @update:showLicenseForm="onShowLicenseForm"
            @validate-address-fields="validateAddressFields"
          />
          <location-services-row
            v-if="model.locationServicesInfo.length > 0"
            :academic-year="academicYearId"
            :data="model.locationServicesInfo"
            :show-form="showLocationServiceForm"
            :specialist-id="specialistId"
            :specialist-info="model.specialistInfo"
            :specialty-type-id="specilistTypes"
            @on-add-location-service="onAddLocationHandler"
            @on-delete-location="onLoad"
            @on-edit-location-service="onEditLocationHandler"
            @update:showLocationServiceForm="onShowLocationServiceForm"
            @validate-address-fields="validateAddressFields"
          />
          <location-services-info
            v-if="
              showLocationServicesInfo &&
                model.locationServicesInfo.length === 0
            "
            class="my-5"
            :company-id="companyId"
            :show="showLocationServicesInfo"
            :specialist-id="specialistId"
            :specialty-type-id="specilistTypes"
            @on-add-location-service="onAddLocationHandler"
            @update:showLocationServiceForm="onShowLocationServiceForm"
          />
        </validation-observer>
      </div>
    </div>
    <custom-tab
      v-else-if="isReadOnly"
      class="w-100 custom-tab-specialist-manager mt-3"
    >
      <custom-tab-item
        active
        :lazy="false"
        title="Información del Especialista"
        @click="onChangeTabHandler(specialistTabsEnum.SPECIALIST_INFO)"
      >
        <div class="col-12">
          <div class="pl-2">
            <validation-observer :ref="mainFormName" v-slot="{}" tag="form">
              <general-info
                ref="generalInfo"
                v-model="model.specialistInfo"
                class="my-5"
                :is-health-dept-no-enabled="isHealthDeptNoEnabled"
                :is-medicaid-documentation-workflow-enabled="
                  isMedicaidDocumentationWorkflowEnabled
                "
                :is-new="isNew"
                :is-read-only="true"
                @update="onUpdateSpecialistHandler"
              />
              <licenses
                ref="licenses"
                v-model="model.licenses"
                :age-ranges="collections.ageRanges"
                class="my-5"
                :document-types="collections.specialistLicenseDocumentTypes"
                :is-medicaid-documentation-workflow-enabled="
                  isMedicaidDocumentationWorkflowEnabled
                "
                :is-read-only="true"
                :show-license-form.sync="showLicenseForm"
                :specialist-id="specialistId"
                :specialist-info="model.specialistInfo"
                :specialty-types="collections.specialtyTypes"
                @delete="onDeleteSpecialistLicenseHandler"
                @delete-document="onDeleteSpecialistLicenseDocumentHandler"
                @delete-document-by-type="onDeleteDocumentByTypeHandler"
                @download-document="onDownloadDocumentHandler"
                @download-documents="onDownloadDocumentsHandler"
                @save="saveOrUpdateLicense"
                @update-specialist-info="saveSpecialistAddressInfo"
                @update:showLicenseForm="onShowLicenseForm"
                @validate-address-fields="validateAddressFields"
              />
              <location-services-row
                v-if="model.locationServicesInfo.length > 0"
                :academic-year="academicYearId"
                :data="model.locationServicesInfo"
                :show-form="showLocationServiceForm"
                :specialist-id="specialistId"
                :specialist-info="model.specialistInfo"
                :specialty-type-id="specilistTypes"
                @on-add-location-service="onAddLocationHandler"
                @on-delete-location="onLoad"
                @on-edit-location-service="onEditLocationHandler"
                @update:showLocationServiceForm="onShowLocationServiceForm"
                @validate-address-fields="validateAddressFields"
              />
              <location-services-info
                v-if="
                  showLocationServicesInfo &&
                    model.locationServicesInfo.length === 0
                "
                class="my-5"
                :company-id="companyId"
                :show="showLocationServicesInfo"
                :specialist-id="specialistId"
                :specialty-type-id="specilistTypes"
                @on-add-location-service="onAddLocationHandler"
                @update:showLocationServiceForm="onShowLocationServiceForm"
              />
            </validation-observer>
          </div>
        </div>
      </custom-tab-item>
      <custom-tab-item
        v-if="isSupervisor"
        :lazy="false"
        title="Información de Supervisión"
        @click="onChangeTabHandler(specialistTabsEnum.SUPERVISED_INFO)"
      >
        <supervision
          ref="supervision"
          :academic-year-id="academicYearId"
          class="my-5"
          :company-id="companyId"
          :filter-options="filterOptions"
          :superviser-specialist-id="specialistId"
        />
      </custom-tab-item>
    </custom-tab>
  </div>
</template>

<script>
import objectToFormData from 'object-to-formdata';
import PageHeader from 'PageHeader';
import { ValidationObserver } from 'vee-validate';
import Board from 'Board';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import SpecialistCompanyStatus from '@/utils/constants/specialistCompanyStatus.js';
import {
  SpecialistSsnSearch as SsnSearch,
  SpecialistGeneralInfo as GeneralInfo,
  SpecialistLicenses as Licenses,
  SpecialistLocationServicesInfo as LocationServicesInfo,
  SpecialistLocationServiceRow as LocationServicesRow,
  SpecialistSupervision as Supervision,
} from './components';
import {
  getDetailInfo as _getDetailInfo,
  getRequestInfo as _getRequestInfo,
  saveOrUpdateSpecialistLicense as _saveOrUpdateSpecialistLicense,
  deleteSpecialistLicense as _deleteSpecialistLicense,
  deleteSpecialistLicenseDocument as _deleteSpecialistLicenseDocument,
  saveOrUpdateSpecialist as _saveOrUpdateSpecialist,
  insertNewSpecialistLocation as _insertNewSpecialistLocation,
  getSpecialistLicenseDocuments as _getSpecialistLicenseDocuments,
  updateSpecialistLocation as _updateSpecialistLocation,
  getValidationsToInactivate as _getValidationsToInactivate,
  isSAEESpecialist as _isSAEESpecialist,
  inactivateSpecialist as _inactivateSpecialist,
  activateSpecialist as _activateSpecialist,
  updateSpecialistInfo as _updateSpecialistInfo,
  updateLicenseFromHd as _updateLicenseFromHd,
  hasDataOnHealthDepartment as _hasDataOnHealthDepartment,
  deleteTemporalSpecialist as _deleteTemporalSpecialist,
} from '@/services/provider/specialist.api.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import { getLocationTypes as _getLocationTypes } from '@/services/common/code.api.js';
import utils from '@/utils/utilities';
import CodeLocationTypes from '@/utils/constants/codeLocationTypes';
import moment from 'moment';
import { getByParameterName } from '@/services/common/sysparameter.api';

const SPECIALIST_MANAGMENT_ROUTE_NAME = 'specialistManagement';

const SPECIALIST_TABS = {
  SPECIALIST_INFO: 0,
  SUPERVISED_INFO: 1,
};

export default {
  name: 'SpecialistManagement',
  components: {
    PageHeader,
    Board,
    CustomTab,
    CustomTabItem,
    ValidationObserver,
    SsnSearch,
    GeneralInfo,
    Licenses,
    LocationServicesInfo,
    LocationServicesRow,
    Supervision,
  },
  mixins: [alertMixin],
  data: () => ({
    isMedicaidDocumentationWorkflowEnabled: false,
    isHealthDeptNoEnabled: false,
    showLocationServiceForm: false,
    showLicenseForm: false,
    managedSpecialistId: null,
    isNew: false,
    consulted: false,
    preSaveRequired: false,
    isSupervisor: false,
    isSupervisedTab: false,
    companyInfo: {},
    collections: {
      specialtyTypes: [],
      ageRanges: [],
      specialistLicenseDocumentTypes: [],
      locationTypes: [],
      specialistLicenseDisciplines: [],
    },
    model: {
      specialistInfo: {
        id: null,
        ssn: null,
        fullName: null,
        firstName: null,
        middleName: null,
        lastMaternalName: null,
        lastPaternalName: null,
        registrationNumber: null,
        email: null,
        postalAddressLine1: null,
        postalAddressLine2: null,
        postalMunicipalityId: null,
        postalZipCode: null,
        personalPhone: null,
        medicaidId: null,
      },
      lincensesInfo: {},
      locationServicesInfo: [],
      specialistLocationServices: [],
      licenses: [],
    },
    showLocationServicesInfo: true,
    filterOptions: {
      specialists: [],
      specialties: [],
    },
  }),
  computed: {
    mainFormName() {
      return 'mainFormName';
    },
    specialist() {
      return 'specialist';
    },
    supervision() {
      return 'supervision';
    },
    headerConfig() {
      return {
        icon: 'fas fa-clipboard-list',
        title: 'Añadir Información de Especialista',
        routes: ['Inicio', 'Proveedores', 'Especialistas', this.routeName],
      };
    },
    routeName() {
      return this.isReadOnly ? 'Ver' : 'Añadir';
    },
    companyId() {
      return +this.$route.params.companyId || null;
    },
    specialistId() {
      return +this.$route.params?.specialistId || null;
    },
    academicYearId() {
      return +this.$route.params?.academicYearId || null;
    },
    isReadOnly() {
      return Boolean(this.specialistId);
    },
    showSaveAction() {
      return this.isNew || this.linkCompanyToSpecialist;
    },
    showDsAction() {
      return this.consulted || !!this.specialistId;
    },
    showSaveSupervisedSpecialistsAction() {
      return this.isSupervisor;
    },
    headerActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left fa-fw',
          variant: 'outline-success',
          click: () => this.$router.push({ name: 'specialistSearch' }),
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save pr-2',
          variant: 'success',
          visible: this.showSaveAction,
          click: () => this.onSubmitHandler(),
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save pr-2',
          variant: 'success',
          visible:
            this.showSaveSupervisedSpecialistsAction && this.isSupervisedTab,
          click: () => this.onSaveSupervisedSpecialistsHandler(),
        },
        {
          text: 'Inactivar',
          icon: 'fas fa-user-alt-slash fa-fw',
          variant: 'outline-success',
          visible:
            !!this.model.specialistInfo.id &&
            this.isSpecialistActive &&
            !this.isSupervisedTab,
          click: () => this.onInactivateHandler(),
        },
        {
          component: 'ActionButton',
          text: 'Consultar DS',
          variant: 'outline-success',
          icon: 'fas fa-file-alt',
          click: this.consultHd,
          visible: this.isHealthDeptNoEnabled && this.showDsAction,
        },
        {
          text: 'Re-Activar',
          icon: 'fas fa-user-check',
          variant: 'success px-1',
          visible:
            !!this.model.specialistInfo.id &&
            !this.isSpecialistActive &&
            !this.showSaveAction &&
            !this.isSupervisedTab,
          click: () => this.onActiveHandler(),
        },
      ];
    },
    companyBoardDetails() {
      return [
        [
          {
            label: 'Año Fiscal:',
            data: this.companyInfo.academicYearDescription,
            icon: 'fas fa-calendar-check',
            cols: 'col-lg-3 pt-2 pl-5',
          },
          {
            label: 'Proveedor:',
            data: this.companyInfo.providerName,
            icon: 'fas fa-address-book',
            cols: 'col-lg-4 pt-2',
          },
          {
            label: 'Especialista:',
            data: this.model.specialistInfo.fullName,
            icon: 'fas fa-address-book',
            cols: 'col-lg-3 pt-2',
          },
          ...(!this.isHealthDeptNoEnabled
            ? [
                {
                  label: 'SSN:',
                  data: this.model.specialistInfo.ssn,
                  icon: 'fas fa-ballot-check',
                  cols: 'col-lg-2 pt-2',
                },
              ]
            : []),
        ],
      ];
    },
    specialistTabsEnum() {
      return SPECIALIST_TABS;
    },
    specilistTypes() {
      const specialties = this.model?.licenses?.map((x) => x.specialtyTypeId);
      return [...new Set(specialties)];
    },
    isSpecialistActive() {
      return this.model?.specialistInfo?.isActive;
    },
    linkCompanyToSpecialist() {
      return Boolean(this.$route.query?.linkCompany);
    },
    hasLoscationServices() {
      return this.model?.specialistLocationServices?.length > 0;
    },
    hasLicenses() {
      return this.model?.licenses?.length > 0;
    },
    excludedLocationTypes() {
      return [CodeLocationTypes.CAAT, CodeLocationTypes.CSEE];
    },
  },
  async beforeRouteUpdate(to, from, next) {
    if (to.path !== from.path) {
      next();
      await this.onLoad();
    }
  },
  async mounted() {
    await this.loadHealthDeptParam();
    await this.onLoad();
  },
  methods: {
    async validateAddressFields() {
      if (this.$refs.generalInfo) {
        await this.$refs.generalInfo.validateForm();
      }
    },
    async saveSpecialistAddressInfo() {
      // Guardar solo la información del especialista sin validación completa
      await this.saveSpecialistInfo();
    },
    async loadHealthDeptParam() {
      const { data } = await getByParameterName(
        'UpdatePeriodRPSpecialistProfileHealthDepartment'
      );
      const { data: medicaidParam } = await getByParameterName(
        'MedicaidDocumentationWorkflowEnabled'
      );
      this.isMedicaidDocumentationWorkflowEnabled =
        medicaidParam.value?.toLowerCase() == 'true' ?? false;

      if (data) {
        const now = moment();
        const start = moment(data.effectiveDate);
        const end = moment(data.effectiveEndDate);

        this.isHealthDeptNoEnabled =
          now.isSameOrAfter(start) && now.isSameOrBefore(end);
      }
    },
    async onLoad() {
      this.managedSpecialistId = this.specialistId;
      await Promise.all([
        this.getRequestInfo(),
        this.getDetailInfo(
          this.specialistId,
          this.companyId,
          this.academicYearId
        ),
      ]);
    },
    async getRequestInfo() {
      const { data } = await _getRequestInfo();
      this.collections = data.collections;
    },
    async getDetailInfo(specialistId, companyId, academicYearId) {
      if (!specialistId || !companyId) return;
      const { data } = await _getDetailInfo(
        specialistId,
        companyId,
        academicYearId
      );
      this.companyInfo = data.companyInfo;
      // If backend returns addresses array, take the first address; otherwise use top-level fields
      const firstAddress =
        data.specialistInfo &&
        Array.isArray(data.specialistInfo.addresses) &&
        data.specialistInfo.addresses.length
          ? data.specialistInfo.addresses[0]
          : null;

      this.model.specialistInfo = {
        ...this.model.specialistInfo,
        ...data.specialistInfo,
        medicaidId: data.specialistInfo.medicalIdentifier || null,
        postalAddressLine1:
          (firstAddress &&
            (firstAddress.postalAddressLine1 || firstAddress.postalAddress)) ||
          data.specialistInfo.postalAddressLine1 ||
          data.specialistInfo.postalAddress ||
          null,
        postalAddressLine2:
          (firstAddress && firstAddress.postalAddressLine2) ||
          data.specialistInfo.postalAddressLine2 ||
          null,
        postalMunicipalityId:
          (firstAddress && firstAddress.postalMunicipalityId) ||
          data.specialistInfo.postalMunicipalityId ||
          null,
        postalZipCode:
          (firstAddress && firstAddress.postalZipCode) ||
          data.specialistInfo.postalZipCode ||
          null,
        personalPhone:
          (firstAddress && firstAddress.personalPhone) ||
          data.specialistInfo.personalPhone ||
          null,
      };
      this.model.licenses = data.licenses
        ? [...data.licenses].map((x) => ({
            ...x,
            showEditLicense: false,
            documents: x.documents.map((d) => ({
              ...d,
              licenseDocumentExpiryDate: d.expirationDate,
            })),
          }))
        : [];
      this.model.locationServicesInfo = data.locationServicesInfo;
      this.isSupervisor = (this.model?.licenses || []).some(
        (item) => item.supervisorFlag
      );

      if (this.isSupervisor) {
        var supervisers =
          this.model.licenses
            .filter((item) => item.supervisorFlag)
            .map((item) => item.specialtyTypeId) ?? [];

        this.filterOptions.specialties =
          this.collections.specialtyTypes
            .filter((item) => supervisers.includes(item.id))
            .map((supervised) => supervised.supervisedSpecialties)
            .reduce((result, parentArray) => {
              parentArray.forEach((childObj) => {
                if (!result.some((y) => y.id === childObj.id))
                  result.push(childObj);
              });

              return result;
            }) ?? [];
      }
    },
    async saveOrUpdateLicense(license) {
      const documentsPayload = license.documents
        .filter((x) => Boolean(x.attachment))
        .map((x) => ({
          ...x,
          expirationDate: x?.licenseDocumentExpiryDate
            ? x?.licenseDocumentExpiryDate?.toISOString()?.split('T')[0]
            : null,
        }));

      const payload = { ...license, documents: documentsPayload };

      const params = objectToFormData(
        { ...payload },
        { indices: true, nullsAsUndefineds: true }
      );

      documentsPayload.forEach((document, index) => {
        for (const key in document) {
          params.append(`documents[${index}].${key}`, document[key]);
        }
      });
      const { data } = await _saveOrUpdateSpecialistLicense(params).catch(
        (err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        }
      );
      if (data.specialistLicenseId) {
        const message = license.specialistLicenseId ? 'actualizada' : 'añadida';
        this.ShowToast(
          'Proceso Exitoso',
          `La licencia ha sido ${message} exitosamente.`,
          'success'
        );
        await this.onLoad();
      }
    },
    onSearchSpecialistHandler({ specialistId, status, ssnOrHdn, isSsnValid }) {
      switch (status) {
        case SpecialistCompanyStatus.New:
          this.isNew = true;
          this.model.specialistInfo = {
            id: null,
            ssn: null,
            fullName: null,
            firstName: null,
            middleName: null,
            lastMaternalName: null,
            lastPaternalName: null,
            registrationNumber: null,
            email: null,
            postalAddressLine1: null,
            postalAddressLine2: null,
            postalMunicipalityId: null,
            postalZipCode: null,
            personalPhone: null,
            medicaidId: null,
          };

          if (isSsnValid) {
            this.model.specialistInfo.ssn = ssnOrHdn;
          } else {
            this.model.specialistInfo.registrationNumber = ssnOrHdn;
          }

          this.model.specialistInfo = { ...this.model.specialistInfo };
          this.companyInfo = {
            ...this.companyInfo,
            companyId: this.companyId,
          };
          this.consulted = true;
          break;
        case SpecialistCompanyStatus.Exist:
          this.loadSpecialist(specialistId, true);
          this.consulted = true;
          break;
        case SpecialistCompanyStatus.InProviderCompany:
          this.ShowToast(
            'Alerta',
            'Ya existe el especialista en la compañía del proveedor.',
            'warning'
          );
          this.loadSpecialist(specialistId, true);
          break;
        case SpecialistCompanyStatus.ActiveInSAEECorp:
          this.ShowToast(
            'Alerta',
            'Se identificó que el especialista se encuentra activo en una corporación de la SAEE.',
            'warning'
          );
          break;
        default:
          break;
      }
    },
    loadSpecialist(specialistId, linkCompanyToSpecialist) {
      this.$router.replace({
        name: SPECIALIST_MANAGMENT_ROUTE_NAME,
        params: {
          specialistId,
          companyId: this.companyId,
          academicYearId: this.academicYearId,
        },
        query: {
          linkCompany: linkCompanyToSpecialist,
        },
      });
    },
    async onSubmitHandler(validate = true) {
      if (this.linkCompanyToSpecialist) {
        const isValid = await this.$refs[this.mainFormName].validate();
        if (!isValid) {
          this.ShowToast(
            'Alerta',
            'Favor completar la información solicitada.',
            'error'
          );
          return;
        }
        if (!this.hasLicenses) {
          this.ShowToast(
            'Alerta',
            'La información de la(s) licencia(s) es(son) requerida(s).',
            'error'
          );
          return;
        }
        if (!this.hasLoscationServices) {
          this.ShowToast(
            'Alerta',
            'La información del(los) lugar(es) de servicio(s) es(son) requerido(s).',
            'error'
          );
          return;
        }
        await this.saveSpecialistInfo();
        return;
      }

      const isValid = await this.$refs[this.mainFormName].validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      const locationServices = this.model.specialistLocationServices ?? [];

      if (validate) {
        const noHasLicenses =
          !this.model.licenses ||
          this.model.licenses.some((l) =>
            l.documents.every((d) => !d.attachment && !d.documentId)
          );
        if (!this.isReadOnly && noHasLicenses) {
          this.ShowToast(
            'Alerta',
            'La información de la(s) licencia(s) es(son) requerida(s)',
            'error'
          );
          return;
        }

        const inValidlocationService =
          !this.isReadOnly &&
          (!locationServices || locationServices.length < 1);
        if (inValidlocationService) {
          this.ShowToast(
            'Alerta',
            'La información del(los) lugar(es) de servicio(s) es(son) requerido(s).',
            'error'
          );
          return;
        }
      }

      const licenses =
        this.model.licenses.map((license) => {
          const documentsPayload = license.documents
            .filter((x) => !!x.attachment)
            .map((x) => ({
              specialistLicenseDocumentTypeId:
                x.specialistLicenseDocumentTypeId,
              attachment: x.attachment,
              expirationDate: x?.licenseDocumentExpiryDate
                ? x?.licenseDocumentExpiryDate?.toISOString()?.split('T')[0]
                : null,
            }));
          return { ...license, documents: documentsPayload };
        }) ?? [];

      let payload = {
        companyInfo: {
          companyId: this.companyId,
          academicYearId: this.academicYearId,
        },
        licenses,
        locationServices,
        specialistInfo: { ...this.model.specialistInfo, id: this.specialistId },
      };
      const params = objectToFormData(
        { ...payload },
        { indices: true, nullsAsUndefineds: true }
      );

      licenses.forEach((license, i) => {
        license.documents.forEach((document, index) => {
          for (const key in document) {
            params.delete(`licenses[${i}][documents][${index}][${key}]`);
            params.append(
              `licenses[${i}].documents[${index}].${key}`,
              document[key]
            );
          }
        });
      });
      const { data } = await _saveOrUpdateSpecialist(params).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });
      if (data.specialistInfo.id) {
        if (this.specialistId) {
          this.ShowToast(
            'Proceso Exitoso',
            'La información ha sido actualizada exitosamente.',
            'success'
          );
        } else {
          this.ShowToast(
            'Proceso Exitoso',
            'El perfil del especialista ha sido creado exitosamente.',
            'success'
          );
        }

        this.managedSpecialistId = data.specialistInfo.id;

        if (this.preSaveRequired) {
          this.consultHd(data.specialistInfo.id);
          return;
        }
        this.isNew = false;
        this.loadSpecialist(data.specialistInfo.id);
      }
    },
    async onChangeSsnHandler() {
      this.showLocationServiceForm = false;
      this.showLicenseForm = false;
      this.isNew = false;
      this.consulted = false;
      this.showLocationServicesInfo = true;
      this.companyInf = {};
      this.collections = {
        specialtyTypes: [],
        ageRanges: [],
        specialistLicenseDocumentTypes: [],
        locationTypes: [],
        specialistLicenseDisciplines: [],
      };
      this.model = {
        specialistInfo: {
          id: null,
          ssn: null,
          fullName: null,
          firstName: null,
          middleName: null,
          lastMaternalName: null,
          lastPaternalName: null,
          email: null,
          registrationNumber: null,
          postalAddressLine1: null,
          postalAddressLine2: null,
          postalMunicipalityId: null,
          postalZipCode: null,
          personalPhone: null,
          medicaidId: null,
        },
        lincensesInfo: {},
        locationServicesInfo: [],
        specialistLocationServices: [],
      };
      this.ShowToast(
        'Confirmación',
        'Los datos fueron reiniciados existomente, puede proceder con una nueva búsqueda.',
        'success'
      );
      await this.onLoad();
    },
    async onDeleteSpecialistLicenseHandler({
      specialistLicenseId,
      specialtyTypeName,
      specialtyTypeId,
      guid,
    }) {
      const isRelated = this.isRelatedToLocationService(specialtyTypeId);
      if (isRelated) {
        this.ShowToast(
          'Alerta',
          `No es posible eliminar la especialidad ya que hay una disciplina asociada a un lugar de servicio`,
          'error'
        );
        return;
      }

      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea <b>Eliminar</b> la especialidad <b>${specialtyTypeName}</b>?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      if (!specialistLicenseId) {
        this.model.licenses = this.model.licenses.filter(
          (x) => x.guid !== guid
        );
        return;
      }

      const { data } = await _deleteSpecialistLicense(
        specialistLicenseId
      ).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });
      if (data) {
        this.ShowToast(
          `Confirmación`,
          'La especialidad ha sido eliminada exitosamente.',
          'success'
        );
        await this.onLoad();
      }
    },
    async onDeleteSpecialistLicenseDocumentHandler(
      {
        documentFilename,
        specialistLicenseDocumentId,
        specialistLicenseDocumentTypeId,
      },
      license
    ) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea <b>Eliminar</b> el archivo <b>${documentFilename}</b>?`,
        'Sí',
        'No'
      );
      if (!answer) return;
      if (!specialistLicenseDocumentId) {
        this.onDeleteDocumentByTypeHandler(
          license,
          specialistLicenseDocumentTypeId
        );
        return;
      }
      const { data } = await _deleteSpecialistLicenseDocument(
        specialistLicenseDocumentId
      ).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });
      if (data) {
        this.ShowToast(
          `Confirmación`,
          'El archivo ha sido eliminado exitosamente.',
          'success'
        );
        this.onDeleteDocumentByTypeHandler(
          license,
          specialistLicenseDocumentTypeId
        );
      }
    },
    onDeleteDocumentByTypeHandler(license, typeId) {
      license.documents = this.collections.specialistLicenseDocumentTypes.map(
        (x) => {
          if (x.id !== typeId)
            return license.documents.find(
              (y) => y.specialistLicenseDocumentTypeId === x.id
            );
          return {
            specialistLicenseDocumentId: null,
            specialistLicenseId: null,
            specialistLicenseDocumentTypeId: x.id,
            specialistLicenseDocumentTypeName: x.name,
            documentId: null,
            attachment: null,
          };
        }
      );
    },
    onDownloadDocumentHandler({ documentId, attachment }) {
      if (documentId) _downloadDocumentByAttachmentId(documentId);
      else {
        let reader = new FileReader();
        reader.readAsDataURL(attachment);
        reader.onloadend = () => {
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          const url = reader.result;
          a.href = url;
          a.download = attachment.name;
          a.click();
          window.URL.revokeObjectURL(url);
        };
      }
    },
    async onDownloadDocumentsHandler({ specialistLicenseId }) {
      const { data } = await _getSpecialistLicenseDocuments(
        specialistLicenseId
      ).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });

      if (data) utils.convertToBlob(data);
    },
    isRelatedToLocationService(specialtyTypeId) {
      const isDuplicated =
        this.specilistTypes.filter((x) => x === specialtyTypeId).length > 1;
      if (isDuplicated) return false;

      return this.model.specialistLocationServices.some((x) =>
        x.specialisties.some((y) => y.specialistTypeId === specialtyTypeId)
      );
    },
    async onAddLocationHandler(location) {
      const valid = this.model.specialistLocationServices.some(
        (x) =>
          x.locationServiceId == location.locationServiceId.id &&
          x.locationTypeId == location.locationTypeId.id &&
          x.municipalityId == location.municipalityId.id
      );

      if (valid) {
        this.ShowToast(
          'Alerta',
          'Ya existe la localización seleccionada.',
          'error'
        );
        return;
      }

      this.model.specialistLocationServices = [
        ...this.model.specialistLocationServices,
        {
          locationServiceId: location.locationServiceId.id,
          locationTypeId: location.locationTypeId.id,
          municipalityId: location.municipalityId.id,
          specialisties: location.disciplines.map((x) => {
            return {
              specialistTypeId: x.specialistLicenseId,
              disciplines: x.disciplines.map((y) => {
                return {
                  discipline: y.disciplineId,
                  subDisciplines: y.subDisciplines.map(
                    (z) => z.subDisciplineId
                  ),
                };
              }),
            };
          }),
        },
      ];
      this.showLocationServicesInfo = false;

      if (this.specialistId) {
        let disiplines = [];
        location.disciplines.forEach((x) => {
          const specialistLicenseId = x.specialistLicenseId;
          const disciplineIds = x.disciplines.map((y) => {
            return {
              disciplineId: y.disciplineId,
              subDisciplines: y.subDisciplines.map((z) => z.subDisciplineId),
            };
          });
          disciplineIds.forEach((y) => {
            disiplines.push({
              specialistLicenseId,
              disciplineTypeId: y.disciplineId,
              subDisciplines: y.subDisciplines,
            });
          });
        });

        const payload = {
          specialistId: this.specialistId,
          locationFiscalYearId: location.locationServiceId.id,
          locationTypeName: location.locationTypeId.name,
          locationTypeId: location.locationTypeId.id,
          municipality: location.municipalityId,
          locationName: location.locationServiceId.name,
          canAssignSpecialistFlag: false,
          selfAssign: false,
          companyId: this.companyId,
          disciplines: disiplines,
        };

        await _insertNewSpecialistLocation(payload)
          .then(() => {
            this.onLoad();
          })
          .catch((err) => {
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error'
            );
          });
      } else {
        this.model.locationServicesInfo = [
          ...this.model.locationServicesInfo,
          {
            locationService: {
              id: location.locationServiceId.id,
              name: location.locationServiceId.name,
            },
            locationType: {
              id: location.locationTypeId.id,
              name: location.locationTypeId.name,
            },
            municipality: {
              id: location.municipalityId.id,
              name: location.municipalityId.name,
            },
            disciplines: location.disciplines,
          },
        ];
      }

      this.ShowToast(
        'Confirmación',
        'El lugar de servicio ha sido añadido exitosamente.',
        'success'
      );
      this.showLocationServiceForm = false;
    },
    async onEditLocationHandler({ model: location, locationServiceSelected }) {
      if (location.specialistLocationId) {
        let disiplines = [];
        location.disciplines.forEach((x) => {
          const specialistLicenseId = x.specialistLicenseId;
          const disciplineIds = x.disciplines.map((y) => {
            return {
              disciplineId: y.disciplineId,
              subDisciplines: y.subDisciplines.map((z) => z.subDisciplineId),
            };
          });
          disciplineIds.forEach((y) => {
            disiplines.push({
              specialistLicenseId,
              disciplineTypeId: y.disciplineId,
              subDisciplines: y.subDisciplines,
            });
          });
        });

        const payload = {
          specialistLocationId: location.specialistLocationId,
          specialistId: this.specialistId,
          locationFiscalYearId: location.locationServiceId.id,
          locationTypeName: location.locationTypeId.name,
          locationTypeId: location.locationTypeId.id,
          municipality: location.municipalityId,
          locationName: location.locationServiceId.name,
          canAssignSpecialistFlag: false,
          selfAssign: false,
          companyId: this.companyId,
          disciplines: disiplines,
        };

        const { data } = await _updateSpecialistLocation(payload).catch(
          (err) => {
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error'
            );
          }
        );

        if (data) {
          this.ShowToast(
            'Confirmación',
            'El lugar de servicio ha sido actualizado exitosamente.',
            'success'
          );
          this.onLoad();
        }
      } else {
        let modelInfoDb = this.model.locationServicesInfo.find(
          (x) => x.locationService.id === locationServiceSelected.id
        );
        let modelDb = this.model.specialistLocationServices.find(
          (x) => x.locationServiceId === locationServiceSelected.id
        );
        if (modelInfoDb) {
          modelInfoDb.disciplines = location.disciplines;
          modelInfoDb.locationService = location.locationServiceId;
          modelInfoDb.locationType = location.locationTypeId;
          modelInfoDb.municipality = location.municipalityId;
        }
        if (modelDb) {
          modelDb.locationServiceId = location.locationServiceId.id;
          modelDb.locationTypeId = location.locationTypeId.id;
          modelDb.municipalityId = location.municipalityId.id;
          modelDb.specialisties = location.disciplines.map((x) => {
            return {
              specialistTypeId: x.specialistLicenseId,
              disciplines: x.disciplines.map((y) => y.disciplineId),
            };
          });
        }
      }
      this.showLocationServiceForm = false;
    },
    async fetchLocationTypes() {
      const { data } = await _getLocationTypes(this.excludedLocationTypes);
      this.collections.locationTypes = data;
    },
    onShowLicenseForm(value) {
      if (value) this.showLocationServiceForm = false;
      this.showLicenseForm = value;
    },
    onShowLocationServiceForm(value) {
      if (value) this.showLicenseForm = false;
      this.showLocationServiceForm = value;
    },
    async consultHd() {
      if (!this.model.specialistInfo.registrationNumber) {
        this.ShowToast(
          'Error',
          'El especialista no tiene un número de registro de salud',
          'error'
        );
        return;
      }

      if (!this.managedSpecialistId) {
        this.preSaveRequired = true;
        await this.onSubmitHandler(false);
        return;
      }

      await _hasDataOnHealthDepartment(
        this.managedSpecialistId,
        this.model.specialistInfo.registrationNumber
      )
        .then(async ({ data }) => {
          if (!data) {
            this.ShowToast(
              'Error',
              'El Número de Registro de Salud no es válido o no se encuentra registrado en el Departamento de Salud.',
              'error'
            );
            return;
          }

          if (this.preSaveRequired) {
            await this.updateLicenseFromHd();
            this.preSaveRequired = false;

            return;
          }

          const answer = await this.ShowCancelModal(
            'Confirmación',
            `¿Se encontraron licencias registradas en el Departamento de salud desea agregarlas al perfil?`,
            'Sí',
            'No'
          );
          if (answer) {
            this.updateLicenseFromHd();
          }
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
    },
    async updateLicenseFromHd() {
      await _updateLicenseFromHd(this.model.specialistInfo.registrationNumber)
        .then(() => {
          if (this.preSaveRequired) {
            this.loadSpecialist(this.managedSpecialistId);
            return;
          }

          this.getDetailInfo(
            this.specialistId,
            this.companyId,
            this.academicYearId
          );
        })
        .catch(() => {
          this.ShowToast(
            'Error',
            'Ocurrió un error cargando los datos',
            'error'
          );
        });
    },
    async onInactivateHandler() {
      const payload = {
        specialistId: this.specialistId,
        companyId: this.companyId,
        fiscalYearId: this.academicYearId,
      };
      const { data: validations } = await _getValidationsToInactivate(
        payload
      ).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });

      if (validations) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está segur(o) que desea inactivar el especialista seleccionado?`,
          'Sí',
          'No'
        );
        if (!answer) return;

        const { data } = await _inactivateSpecialist(payload).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });

        if (data) {
          this.onLoad();
          this.ShowToast(
            'Proceso Exitoso',
            'El especialista ha sido inactivado existosamente.',
            'success'
          );
        }
      }
    },
    async onActiveHandler() {
      const payload = {
        specialistId: this.specialistId,
        companyId: this.companyId,
        fiscalYearId: this.academicYearId,
      };

      const { data: validation } = await _isSAEESpecialist(payload).catch(
        (err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
          return;
        }
      );

      if (validation) {
        this.ShowToast(
          'Alerta',
          'No se pudo reactivar el especialista ya que se encuentra activo en la SAEE.',
          'error'
        );
        return;
      }

      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está segur(o) que desea reactivar el especialista seleccionado?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      await _activateSpecialist(payload).catch((error) => {
        const message = error?.response?.data?.message ?? error.message;
        this.ShowToast('Alerta', `${message}`, 'error');
        return;
      });

      this.ShowToast(
        `Confirmación`,
        'El especialista ha sido reactivado exitosamente.',
        'success'
      );

      await this.onLoad();
    },
    async saveSpecialistInfo() {
      const payload = {
        specialistId: this.specialistId,
        companyId: this.companyId,
        firstName: this.model.specialistInfo.firstName,
        middleName: this.model.specialistInfo.middleName,
        lastPaternalName: this.model.specialistInfo.lastPaternalName,
        lastMaternalName: this.model.specialistInfo.lastMaternalName,
        email: this.model.specialistInfo.email,
        registrationNumber: this.model.specialistInfo.registrationNumber,
        postalAddress: this.model.specialistInfo.postalAddress,
        postalAddressLine1: this.model.specialistInfo.postalAddressLine1,
        postalAddressLine2: this.model.specialistInfo.postalAddressLine2,
        postalMunicipalityId: this.model.specialistInfo.postalMunicipalityId,
        postalZipCode: this.model.specialistInfo.postalZipCode,
        personalPhone: this.model.specialistInfo.personalPhone,
        medicalIdentifier: this.model.specialistInfo.medicaidId,
        nationalIdentifier: this.model.specialistInfo.nationalIdentifier,
      };
      const { data: response } = await _updateSpecialistInfo(payload).catch(
        (err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        }
      );
      if (response) {
        this.ShowToast(
          'Proceso Exitoso',
          'Los datos han sido guardados exitosamente.',
          'success'
        );
        this.getDetailInfo(
          this.specialistId,
          this.companyId,
          this.academicYearId
        );
      }
    },
    async onUpdateSpecialistHandler() {
      const isValid = await this.$refs[this.mainFormName].validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      await this.saveSpecialistInfo();
    },
    onChangeTabHandler(tabIndex) {
      this.isSupervisedTab = tabIndex === SPECIALIST_TABS.SUPERVISED_INFO;
    },
    async onSaveSupervisedSpecialistsHandler() {
      await this.$refs[this.supervision].onSaveSupervisedSpecialists();
    },
  },
  async beforeRouteLeave(_, from, next) {
    if (
      this.isNew &&
      this.managedSpecialistId &&
      this.managedSpecialistId > 0 &&
      (!this.model.specialistLocationServices ||
        this.model.specialistLocationServices.length === 0)
    ) {
      const discardText = `<span class="text-danger"> al salir la información se perderá</span>`;

      const { value: confirmed, dismiss } = await this.ShowCancelModalClosable(
        'Confirmación',
        `Usted cuenta con información sin documentar, ${discardText} ¿desea continuar con la documentación? `,
        `Continuar`,
        'Salir',
        true
      );
      const cancelled = ['close', 'backdrop'].includes(dismiss);
      if (cancelled || confirmed) return false; //keep in the screen if don't want to save but stay

      await _deleteTemporalSpecialist(this.managedSpecialistId);
    }
    next();
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.custom-tab-specialist-manager ::v-deep {
  .custom-tab-container {
    margin-left: 1px !important;
    margin-right: 1px !important;

    .nav-item {
      .nav-link {
        &.active {
          border-bottom: 3px solid map-get($colors, 'orange') !important;
          color: map-get($colors, 'orange') !important;
        }
      }
    }
  }
}
</style>
